import React from "react";
import { Typography, Container, Box } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import Navbar from "./Navbar";
import Footer from "./Footer"
function PrivacyPolicy() {
  return (
    <>
    <Navbar/>
    <Container maxWidth="md" sx={{ paddingY: 4,marginTop:'16vh' }}>
      {/* Header */}
      <Box textAlign="center" sx={{ marginBottom: 4 }}>
      <Typography
        variant="h4"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          mb: 1,
        }}
      >
        Privacy Policy
      </Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
        <KeyboardArrowDown fontSize="large" />
      </Box>
      {/* Applicable Laws Section */}
      <Box sx={{ marginBottom: 4 }}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          textAlign: "left",
        }}
      >
          Applicable Laws
        </Typography>
        <Typography variant="body1">
          Infinity Automotive operates its website from the United States. We do
          not claim that the content on our website is suitable or accessible in
          all locations, and accessing it from jurisdictions where its contents
          are illegal is prohibited. Those who choose to use our site from
          outside the U.S. are responsible for compliance with local laws. Any
          disputes related to the use of this site will be governed by U.S.
          federal law and the laws of the state where our headquarters are
          located. Any legal proceedings must be brought in the appropriate
          state or federal courts, and by using this site, you agree to their
          jurisdiction.
        </Typography>
      </Box>

      {/* User Accounts Section */}
      <Box sx={{ marginBottom: 4 }}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          textAlign: "left",
        }}
      >
          User Accounts, Passwords, and Security
        </Typography>
        <Typography variant="body1">
          Certain features of our website may require you to create an account.
          You must provide accurate and complete information during
          registration. You are responsible for maintaining the confidentiality
          of your account credentials, including your password, and for all
          activities under your account. Notify us immediately of any
          unauthorized use of your account. Infinity Automotive is not liable
          for losses resulting from unauthorized account access, but you may be
          held responsible for damages incurred by us or third parties due to
          misuse of your account.
        </Typography>
      </Box>

      {/* Use of Content Section */}
      <Box sx={{ marginBottom: 4 }}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          textAlign: "left",
        }}
      >
          Use of Content
        </Typography>
        <Typography variant="subtitle1" gutterBottom >
          <i>Infinity Automotive Content:</i>
        </Typography>
        <Typography variant="body1">
          All content on this site, including text, images, and trademarks, is
          the exclusive property of Infinity Automotive and may not be copied,
          modified, or distributed without prior written consent.
        </Typography>
        <Typography variant="subtitle1" gutterBottom sx={{ marginTop: 2 }}>
          <i>User-Generated Content:</i>
        </Typography>
        <Typography variant="body1">
          By submitting any content to our website, you confirm that you have
          the rights to share it and grant Infinity Automotive a non-exclusive,
          royalty-free, perpetual, and irrevocable license to use, modify, and
          distribute that content. You must not upload illegal, offensive, or
          infringing materials. We reserve the right to remove any
          user-generated content at our discretion.
        </Typography>
      </Box>

      {/* Access to Your Data Section */}
      <Box sx={{ marginBottom: 4 }}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          textAlign: "left",
        }}
      >
          Access to Your Data
        </Typography>
        <Typography variant="body1">
          If you are not a registered user, we do not retain any personal data
          about you. If you have created an account, your information may be
          accessed by our administrative and support teams to facilitate
          customer service and system management.
        </Typography>
      </Box>

      {/* Data Retention Section */}
      <Box sx={{ marginBottom: 4 }}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          textAlign: "left",
        }}
      >
          Data Retention
        </Typography>
        <Typography
          variant="body1"
        sx={{
         textAlign: "left",
        }}
      >
          When you submit a form or request a quote, we store your data for as
          long as necessary to process your request. You may request its
          removal at any time.
        </Typography>
      </Box>

      {/* Collection and Use of Mobile Numbers Section */}
      <Box sx={{ marginBottom: 4 }}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          textAlign: "left",
        }}
      >
          Collection and Use of Mobile Numbers
        </Typography>
        <Typography variant="body1">
          When you provide your mobile number, you consent to receive SMS
          notifications regarding orders, account updates, and promotional
          offers (if opted in). Your number is not sold or shared for marketing
          purposes. However, it may be registered with telecommunications
          regulators and shared with our SMS service provider to ensure
          compliance with messaging laws.
        </Typography>
        <Typography variant="subtitle1" gutterBottom sx={{ marginTop: 2 }}>
       <i>   Opt-In and Opt-Out Procedures:</i>
        </Typography>
        <Typography variant="body1">
          By providing your phone number and opting in, you agree to receive SMS
          messages from us. You can opt out at any time by replying "STOP" to
          any message. To receive assistance, reply "HELP" or contact us
          directly.
        </Typography>
      </Box>

      {/* Security of Your Data Section */}
      <Box sx={{ marginBottom: 4 }}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          textAlign: "left",
        }}
      >
          Security of Your Data
        </Typography>
        <Typography variant="body1">
          We take extensive security measures to protect your data, including
          SSL encryption to safeguard communications. In case of a data breach,
          we will take immediate steps to secure our system, notify affected
          users, and implement corrective actions.No mobile phone information will be shared with third parties/affliates for marketing/promotionL purposes.
        </Typography>
      </Box>

      {/* Security Measures Section */}
      <Box>
      <Typography
        variant="h6"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          textAlign: "left",
        }}
      >
          Security Measures
        </Typography>
        <Typography variant="body1">
          Infinity Automotive uses encryption protocols to protect user
          communications and personal data. In the event of a breach, affected
          users will be contacted, and necessary security actions will be taken
          immediately.
        </Typography>
      </Box>
    </Container>
    <Footer/>
    </>
  );
}

export default PrivacyPolicy;
